export interface KngTableLoader {
    state: KngTableLoaderState;
}
export interface KngTableLoaderState {
    noOfColumns: number;
    noOfRows: number;
    headerArray?: string[];
}
